import { createSelector, createStructuredSelector } from 'reselect';
import config from 'config';
import FeatureToggleUtils from 'FeatureToggleUtils';

import { loginTypes } from '../constants/Enums';
import { eventSelector, getRegistrationsUrl } from './EventSelectors';

const loginSettingsSelector = state => state.loginReducer;

const loginTypeSelector = state => state.loginReducer.loginType;

export const ssoAccountIdSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => loginSettings.ssoAccountConfigId
);

export const enableLoginRegistrationPopUpSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => loginSettings.enableLoginRegistrationPopUp
);

export const isLoginShownSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => loginSettings.isLoginShown
);

export const offsetTopSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => loginSettings.offsetTop
);

export const loginLoadingStateSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => ({
        isLoading: loginSettings.isLoading,
        spinnerOrigin: loginSettings.spinnerOrigin
    })
);

export const enableTicketIdLoginSelector = createSelector(
    loginTypeSelector,
    (loginType) => loginTypes.EMAIL_AND_TICKET_ID === loginType
);

export const isSSOLoginSelector = createSelector(
    loginTypeSelector,
    (loginType) => loginTypes.SSO === loginType
);

export const getRedirectRingUrl = createSelector(
    eventSelector,
    state => state.ringReducer,
    (event, { available, enabled }) => {
        const isRingFeatureEnabled = FeatureToggleUtils.isFeatureEnabled('ring');
        const isRingWorks = isRingFeatureEnabled && available && enabled;

        if (!isRingWorks) {
            return null;
        }

        // can't use this method isBizzaboInternalWebsiteWhiteLabeled(event)
        // because it included independent url as well
        const isOnlyWhiteLabel = event.websiteType === 'whitelabel';
        const isWhiteLabelVenueEnabled = event.venueWhitelabel === 'READY';

        if (isWhiteLabelVenueEnabled && isOnlyWhiteLabel) {
            if (!event.onlyEventDomain) {
                return `https://${event.whitelabelUrl}${event.whitelabelPath}/venue`;
            }
            return `https://${event.whitelabelUrl}/venue`;
        } else if (config.ringUrl) {
            const path = event['unique-name'];
            return `${config.ringUrl}/${path}`;
        }

        return null;
    }
);

export const isSsoEmailErrorModalVisibleSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => loginSettings.showSsoModal
);

export const ssoErrorEmailSelector = createSelector(
    loginSettingsSelector,
    (loginSettings) => loginSettings.errorEmail
);

export const ssoEmailErrorModalSelector = createStructuredSelector({
    showSsoErrorModal: isSsoEmailErrorModalVisibleSelector,
    errorEmail: ssoErrorEmailSelector,
    registrationsUrl: getRegistrationsUrl,
});

export const cookieConsentSrcSelector = createSelector(
    loginSettingsSelector,
    loginSettings => loginSettings?.cookieConsentSrc || false
);
